import axios from 'axios';
import { urlsServices } from '@/config/urls';

let httpUrl = `${urlsServices.GETWAY}api/acompanhamento`;
export const createAcompanhamento = async (formBuilder) => {
  return await axios.post(`${httpUrl}/create`, formBuilder).then((response) => response);
};

export const getAcompanhamento = async () => {
  return await axios.get(`${httpUrl}/list`).then((response) => response);
};
export const getAcompanhamentoByIdRegistroAtendimento = async (idRegistroAtendimento) => {
  return await axios.get(`${httpUrl}/registro-atendimento/${idRegistroAtendimento}`).then((response) => response);
};

export const getAcompanhamentoById = async (id) => {
  return await axios.get(`${httpUrl}/${id}`).then((response) => response);
};

export const deleteAcompanhamento = async (id) => {
  return await axios.delete(`${httpUrl}/${id}`).then((response) => response);
};
